// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1NkRp","box":"WorkspacesBox_box__3dWAw","node":"WorkspacesBox_node__2SPws"};